var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, ButtonGroup, Container, FormLabel, Loader, Stack, Textarea, } from '@noom/wax-component-library';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from '../../../core/components/Modal';
import useUser from '../../../core/hooks/useUser';
import { useConfig } from '../../../social/providers/ConfigProvider';
import { ErrorMessage } from '../CommunityForm/styles';
import { LANGUAGE_METADATA } from '../../../social/constants';
export const StingModal = ({ userAccessCode, pathToContent, isOpen, onClose }) => {
    var _a;
    const { formatMessage } = useIntl();
    const { formState: { errors }, register, handleSubmit, reset, setError, } = useForm();
    const { isUserCurrentlyInStingDashCallback, addCoachNoteCallback, transferUserToStingCallback } = useConfig();
    const [userInStingDash, setUserInStingDash] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (isOpen) {
            (() => __awaiter(void 0, void 0, void 0, function* () {
                const inStingDash = yield isUserCurrentlyInStingDashCallback(userAccessCode);
                setUserInStingDash(inStingDash);
                setIsLoading(false);
            }))();
        }
    }, [userAccessCode, isOpen]);
    useEffect(() => {
        setIsLoading(true);
        reset();
    }, [isOpen]);
    const { user } = useUser(userAccessCode);
    const userLocale = ((_a = user === null || user === void 0 ? void 0 : user.metadata) === null || _a === void 0 ? void 0 : _a[LANGUAGE_METADATA]) || 'en';
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        let canAttachNote = true;
        if (!userInStingDash) {
            canAttachNote = yield transferUserToStingCallback(userAccessCode, userLocale);
        }
        if (canAttachNote) {
            const realPath = pathToContent.replace(/.+\/social\//, `${window.location.protocol}//${window.location.hostname}/`);
            addCoachNoteCallback(userAccessCode, userLocale, `${data.coachNotes}\n\nPath to Circles content:\n${realPath}`);
        }
        onClose();
    });
    const validateAndSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (!data.coachNotes) {
            setError('coachNotes', {
                message: formatMessage({ id: 'sting.notesAreRequired' }),
            });
            return;
        }
        onSubmit(data);
    });
    const statusLabelId = userInStingDash ? 'sting.userInStingDash' : 'sting.userNotInStingDash';
    const buttonLabelId = userInStingDash ? 'sting.addNewNote' : 'sting.transferUser';
    return (React.createElement(Modal, { isOpen: isOpen, "data-qa-anchor": "sting-modal", title: isLoading ? '' : formatMessage({ id: statusLabelId }), onCancel: onClose }, isLoading ? (React.createElement(Container, { centerHorizontal: true },
        React.createElement(Loader, { size: "md", colorScheme: "primary" }))) : (React.createElement("form", { onSubmit: handleSubmit(validateAndSubmit) },
        React.createElement(Stack, null,
            React.createElement(Box, null,
                React.createElement(FormLabel, null,
                    React.createElement(FormattedMessage, { id: "sting.coachNotes" })),
                React.createElement(Textarea, Object.assign({ placeholder: formatMessage({ id: 'sting.notesPlaceholder' }) }, register('coachNotes'))),
                React.createElement(ErrorMessage, { errors: errors, name: "coachNotes" })),
            React.createElement(ButtonGroup, { w: "100%", justifyContent: "center" },
                React.createElement(Button, { colorScheme: "primary", type: "submit" },
                    React.createElement(FormattedMessage, { id: buttonLabelId }))))))));
};
//# sourceMappingURL=StingModal.js.map